import { FC } from "react";
import spinWheel from "../../../assets/images/spinWheel.png";
import spinWheelPin from "../../../assets/images/spinWheelPin.png";

interface IWheelOfFortuneHelper {
    spinNumberData: any
}

const WheelOfFortuneHelper: FC<IWheelOfFortuneHelper> = ({spinNumberData}) => { 
    return(
        <div className="wheel_of_fortune_helper center_horizontally_and_vertically">
            <div className="wheel_of_fortune_helper_wrapper center_horizontally_and_vertically">
                <img className={`wheel_of_fortune_helper_png ${"rotate_to_number_"+spinNumberData?.token}`} src={spinWheel} alt="wheel" />
                <img className="wheel_of_fortune_pin_heper_png" src={spinWheelPin} alt="pin" />
            </div>
        </div> 
    )
}

export default WheelOfFortuneHelper;